import { render, staticRenderFns } from "./HomeHelpComponent.vue?vue&type=template&id=4f1f0795&scoped=true&"
import script from "./HomeHelpComponent.vue?vue&type=script&lang=js&"
export * from "./HomeHelpComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeHelpComponent.vue?vue&type=style&index=0&id=4f1f0795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f0795",
  null
  
)

export default component.exports